// @core/api/endpoints/calendar/update_calendar.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CalendarResponse,
  UpdateCalendarRequest,
} from '../../../types/calendar';

const BASE_PATH = '/calendar';

/**
 * Update calendar
 * Updates calendar fields specified in the field mask including name, description, color, settings, and visibility.
 */
export async function UpdateCalendar(
  calendar_id: string,
  data: UpdateCalendarRequest,
  options?: RequestOptions
): Promise<CalendarResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/calendars/:calendar_id`;
  requestPath = requestPath.replace(':calendar_id', encodeURIComponent(calendar_id));
  const requestOptions = options;
  return client.put<CalendarResponse>(requestPath, data, requestOptions);
}
